import apiUrl from '../config/apiUrl';
import fetchUrl from '../utils/fetchUrl';

export const NEWS_LIST = async () => {
  return await fetchUrl({
    url: `${apiUrl}news/newsList`,
    method: 'POST',
    body: {
      pageNumber: 0,
      pageSize: 5,
    },
  });
};
export const NEWS_SHOW_DETAILS = async (id: number) => {
  return await fetchUrl({
    url: `${apiUrl}news/showDetail?id=${id}`,
    method: 'GET',
  });
};
